import { SCREEN_SIZE } from 'src/app/core/constants/screen-size';
import { MatDialog } from '@angular/material/dialog';
import { AfterViewInit, Component, OnDestroy, OnInit, ViewChild, ViewChildren } from '@angular/core';
import { MatSort } from '@angular/material/sort';
import { Subject, Subscription } from 'rxjs';
import { NotificationService } from 'src/app/core/services/notification.service';
import { CommonService } from 'src/app/core/services/common.service';
import { BaseComponent } from 'src/app/shared/components/base/base.component';
import { Message } from 'src/app/core/class/message';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { DocumentService } from 'src/app/core/services/document.service';
import { UserService } from 'src/app/core/services/user.service';
import { DocumentTypeService } from 'src/app/core/services/document-type.service';
import { FormBuilder, FormGroup, NgForm, Validators } from '@angular/forms';
import { MatSelect } from '@angular/material';
import { ReportService } from '../../../../../../core/services/report.service';
import FileUtils from '../../../../../../core/services/file-utils';
import { takeUntil } from 'rxjs/operators';
import moment from 'moment';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';
import * as _ from 'lodash';
@Component({
  selector: 'app-sms-money-report',
  templateUrl: './sms-money-report.component.html',
  animations: [
    trigger('detailExpand', [
      state('void', style({ height: '0px', minHeight: '0', visibility: 'hidden' })),
      state('*', style({ height: '*', visibility: 'visible' })),
      transition('void <=> *', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
})
export class SmsMoneyReportComponent extends BaseComponent implements OnInit, AfterViewInit, OnDestroy {
  /**
   * Check status of document for process update
   */
  checkUpdateDocument = false;
  public warningContractQuantity = false;
  public mediaBreakpoint: any;
  public SCREEN_SIZE = SCREEN_SIZE;
  subscription: Subscription;
  enterpriseId;
  checkFocus = true;
  dateErr = '';
  mode = 6;
  isShowWarningSelectedFromDate: boolean = false;
  isShowWarningSelectedToDate: boolean = false;

  @ViewChild(MatSort, { static: false }) sort: MatSort;
  @ViewChild('myForm', { static: false }) ngForm: NgForm;
  @ViewChild('timePeriod', { static: false }) timePeriod: MatSelect;
  @ViewChildren('focusInput') focusInput;

  private _onDestroy = new Subject<void>();
  form: FormGroup;
  exportForm: FormGroup;
  showSpinner = false;
  constructor(
    private formBuilder: FormBuilder,
    private documentTypeService: DocumentTypeService,
    private usService: UserService,
    private documentService: DocumentService,
    private dialog: MatDialog,
    private notificationService: NotificationService,
    public commonService: CommonService,
    public message: Message,
    public reportService: ReportService,
    private spinnerService: Ng4LoadingSpinnerService,
    private toastr: ToastrService,
    private translateService: TranslateService
  ) {
    super(commonService, message);
  }

  ngOnInit() {
    this.enterpriseId = localStorage.getItem('enterpriseId');
    this.notificationService.subscribeErrorService();
    window.scrollTo(0, 0);

    this.form = this.formBuilder.group({
      fromDate: [null, [Validators.required]],
      toDate: [null, [Validators.required]],
      timePeriod: ['day', Validators.required]
    });
    const maxAllowCreatedTimeFrom = moment(Date.now()).subtract(31, 'd');
    this.formControls.toDate.setValue(moment(Date.now()).format('YYYY-MM-DD'));
    this.formControls.fromDate.setValue(maxAllowCreatedTimeFrom.format('YYYY-MM-DD'));

    this.formControls.timePeriod.valueChanges.pipe(takeUntil(this._onDestroy)).subscribe(value => {
      if (value != null) {
        const currentToDate = moment(this.formControls.toDate.value);
        let maxAllowCreatedTimeTo;
        if (value === 'day') {
          maxAllowCreatedTimeTo = moment(this.formControls.fromDate.value).add(31, 'd');
        } else if (value === 'week') {
          maxAllowCreatedTimeTo = moment(this.formControls.fromDate.value).add(10, 'weeks').subtract(1, 'd');
        } else if (value === 'month') {
          maxAllowCreatedTimeTo = moment(this.formControls.fromDate.value).add(12, 'months').subtract(1, 'd');
        }
        if (!currentToDate.isBetween(moment(this.formControls.fromDate.value), maxAllowCreatedTimeTo, undefined, '[]')) {
          this.formControls.toDate.setValue(maxAllowCreatedTimeTo.format('YYYY-MM-DD'));
        }
      }
    });
  }

  ngAfterViewInit(page: number = 0) {
    setTimeout(_ => this.focusInput.first.nativeElement.focus());
  }

  ngOnDestroy() {
    this.notificationService.unsubscribeErrorService();
  }

  /**
   * Get data when init
   */
  loadData() {
  }

  onExportReport() {
    if (this.form) {
      this.exportForm = _.cloneDeep(this.form)
      //   this.showSpinner = true;
      //   this.spinnerService.show();
      //   this.reportService.exportTotalSmsMoney(this.form.value).subscribe(rs => {
      //     this.showSpinner = false;
      //     this.toastr.success(this.translateService.instant('toastr_report.download_success'));
      //     FileUtils.downLoadFile(rs, 'application/octet-stream', 'Bao_cao_tien_su_dung_sms.xlsx');
      //     this.spinnerService.hide();
      //   }, err => {
      //     this.spinnerService.hide();
      //     this.toastr.error(this.translateService.instant('toastr_report.download_error'));
      // });
    }
  }

  get formControls() {
    return this.form.controls;
  }

  changeDatePickerFromDate(event) {
    this.isShowWarningSelectedToDate = false;
    this.isShowWarningSelectedFromDate = false;
    if (event.value != null) {
      const timePeriod = this.formControls.timePeriod.value;
      const currentToDate = moment(this.formControls.toDate.value);
      let maxAllowCreatedTimeTo;
      if (timePeriod === 'day') {
        maxAllowCreatedTimeTo = moment(event.value).add(31, 'd');
      } else if (timePeriod === 'week') {
        maxAllowCreatedTimeTo = moment(event.value).add(10, 'weeks').subtract(1, 'd');
      } else if (timePeriod === 'month') {
        maxAllowCreatedTimeTo = moment(event.value).add(12, 'months').subtract(1, 'd');
      }
      if (!currentToDate.isBetween(moment(event.value), maxAllowCreatedTimeTo, undefined, '[]')) {
        this.formControls.toDate.setValue(maxAllowCreatedTimeTo.format('YYYY-MM-DD'));
        // this.isShowWarningSelectedFromDate = true;
      }
    }
  }

  changeDatePickerToDate(event) {
    this.isShowWarningSelectedToDate = false;
    this.isShowWarningSelectedFromDate = false;
    if (event.value != null) {
      const timePeriod = this.formControls.timePeriod.value;
      const currentFromDate = moment(this.formControls.fromDate.value);
      let maxAllowCreatedTimeFrom;
      if (timePeriod === 'day') {
        maxAllowCreatedTimeFrom = moment(event.value).subtract(31, 'd');
      } else if (timePeriod === 'week') {
        maxAllowCreatedTimeFrom = moment(event.value).subtract(10, 'weeks').add(1, 'd');
      } else if (timePeriod === 'month') {
        maxAllowCreatedTimeFrom = moment(event.value).subtract(12, 'months').add(1, 'd');
      }
      if (!currentFromDate.isBetween(maxAllowCreatedTimeFrom, moment(event.value), undefined, '[]')) {
        this.formControls.fromDate.setValue(maxAllowCreatedTimeFrom.format('YYYY-MM-DD'));
        // this.isShowWarningSelectedToDate = true;
      }
    }
  }

  filterForm(event: any) {
    console.log(event);
    // this.formControls.timePeriod.setValue(event.timePeriod);

    this.form.setValue({
      fromDate: moment(event.totalReportSearch.fromDate).format('YYYY-MM-DD'),
      toDate: moment(event.totalReportSearch.toDate).format('YYYY-MM-DD'),
      timePeriod: event.totalReportSearch.timePeriod,
    });
    window.scrollTo(0, 0);
  }

  getErrorDateMessageRange(pickerInput: string, isExpired?: boolean): string {
    if (!pickerInput || pickerInput === '') {
      return null;
    }
    return this.message.getMessage('validation.format_of_date_consumption');
  }
}
